module.exports = __webpack_public_path__ + "static/spinner-textprogress-dont-d6843ef97e6be480070ee84a119f3c45.png";